import type { ReactNode } from 'react';
import { useTranslation } from './context';
import { isTranslatable } from './format';
import type { InterpolationValues, Translation } from './types';

interface TranslateProps {
  text: Translation | ReactNode;
  values?: InterpolationValues;
  count?: number;
}

export const Translate = ({ text, values, count }: TranslateProps) => {
  const { translate } = useTranslation();

  return isTranslatable(text) ? (
    <>{translate(text, { values, count })}</>
  ) : (
    <>{text}</>
  );
};
